const GRID = { style: 'thin', color: { argb: 'FFD9D9D9' } };

export const TICKETS_EXPORT_STYLES = {
  sheetName: 'Tickets',
  headerRowHeight: 36,
  dataRowHeight: 57,
  columnWidths: [
    18, // Organization Name -- Middle
    12, // Ticket Id -- Middle and bold
    41, // Title -- Middle and Bold
    56, // Summary
    13, // Type
    16, // Priority
    23, // Raised By
    23, // Asignee
    14, // Created At -- Middle
    14, // Updated At -- Middle
    23, // Updated By
    20, // Status  
    56, // Latest Comment
    23, // Commented By
  ],
  defaultColumnWidth: 18,
  header: {
    font: { name: 'Calibri', size: 11, bold: true, color: { argb: 'FFFFFFFF' } },
    fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF1F3864' } },
    alignment: { vertical: 'middle', horizontal: 'center', wrapText: true },
    border: { top: GRID, left: GRID, bottom: GRID, right: GRID },
  },
  body: {
    font: { name: 'Calibri', size: 11, color: { argb: 'FF1A202C' } },
    alignment: { vertical: 'middle', horizontal: 'left', wrapText: true },
    border: { top: GRID, left: GRID, bottom: GRID, right: GRID },
  },
  /** Alternating data rows (subtle gray) */
  zebraFill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFF5F7FA' } },
  valueStyles: {
    status: {
      READY: {
        fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE9F7EF' } },
        font: { color: { argb: 'FF1E8449' }, bold: true },
      },
      'IN PROGRESS': {
        fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE8F4FD' } },
        font: { color: { argb: 'FF1A6FA8' }, bold: true },
      },
      'USER VALIDATION': {
        fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFF4ECF7' } },
        font: { color: { argb: 'FF6C3483' }, bold: true },
      },
      DONE: {
        fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE6FFFA' } },
        font: { color: { argb: 'FF0F766E' }, bold: true },
      },
    },
    priority: {
      CRITICAL: {
        fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFE8E8' } },
        font: { color: { argb: 'FFC0392B' }, bold: true },
      },
      MAJOR: {
        fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFEF5E7' } },
        font: { color: { argb: 'FFCA6F1E' }, bold: true },
      },
      MINOR: {
        fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFEF9E7' } },
        font: { color: { argb: 'FFB7950B' }, bold: true },
      },
      ENHANCEMENT: {
        fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFEBF5FB' } },
        font: { color: { argb: 'FF1A5276' }, bold: true },
      },
    },
    type: {
      BUG: {
        fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFF9EBEA' } },
        font: { color: { argb: 'FFC0392B' }, bold: true },
      },
      INCIDENT: {
        fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFF0E0' } },
        font: { color: { argb: 'FFC0580E' }, bold: true },
      },
      TASK: {
        fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFEAF6EE' } },
        font: { color: { argb: 'FF2D3748' }, bold: true },
      },
      QUERY: {
        fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE2E8F0' } },
        font: { color: { argb: 'FF1A202C' }, bold: true },
      },
      STORY: {
        fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFF3E8FF' } },
        font: { color: { argb: 'FF6B21A8' }, bold: true },
      },
    },
  },
};
